export default __webpack_public_path__ + "static/social media 7-62e6214deb9bf9881dae95df2bc91c6b.webp";